import { AppLayout } from '@/components/layout/AppLayout';
import { Menu } from '@/components/layout/Menu';
import { SpriteSvg } from '@/components/common/SpriteSvg';
import { Link } from 'react-router-dom';
import logoErrorPageSvg from '@/assets/images/logo_error_page.svg';

export const Error404 = () => {
  return (
    <AppLayout>
      <div className="global-container">
        <Menu />
        <label htmlFor="menu-opener" className="floating-menu-opener">
          <SpriteSvg name={'icon-floating-menu'} className={'i'} />
        </label>

        <div className="content-main">
          <section className="error">
            <div className="container">
              <img src={logoErrorPageSvg} className="img" />
              <p>
                お探しのページは
                <br />
                見つかりませんでした
              </p>
              <Link to="/">トップページへ戻る</Link>
            </div>
          </section>
        </div>
      </div>
    </AppLayout>
  );
};
